export function featuresAccordion() {
    const accordionBlock = $(".features-accordion");
    accordionBlock.on("click", ".show-more, h3, .h3", function (e) {
        const button = $(this);
        let accordion = button.parents(".features-accordion");
        let parent = button.parent();
        if (parent.hasClass("opened")) {
            parent.removeClass("opened").find(".hidden-info").slideUp();
            parent.find(".show-more span").text("Learn More");
        } else {
            accordion.find(".features-accordion-item").removeClass("opened").find(".hidden-info").slideUp();
            accordion.find(".show-more").find("span").text("Learn More");
            parent.addClass("opened").find(".hidden-info").slideDown();
            parent.find(".show-more span").text("See Less");
        }
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuresAccordion.js